import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=2dfa0f66&scoped=true&lang=pug&"
import script from "./InputWrapper.vue?vue&type=script&lang=js&"
export * from "./InputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InputWrapper.vue?vue&type=style&index=0&id=2dfa0f66&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa0f66",
  null
  
)

export default component.exports